const Default = {
  BASE_URL: "https://staff.nsuk.edu.ng",
  // BASE_URL: "http://localhost:8082",
  // BASE_URL: "https://dev.nsuk.edu.ng:8083"
  // BASE_URL: "https://dev.nsuk.edu.ng"
}

export default Default
